// extracted by mini-css-extract-plugin
module.exports = {"root":"MonthRangeSwitch_root__2bO1l","range":"MonthRangeSwitch_range__16tpA","disabled":"MonthRangeSwitch_disabled__2NcTL"};